import * as React from "react";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import Modal from "react-bootstrap/Modal";
import { DM_PT_DataSheet } from "../models/DM_PT_DataSheet";
import { DeviceData } from "../models/DeviceData";
import Draggable from "react-draggable";



interface Props {
    zoom: number;
    devices: Array<DeviceData>;
    closeModal: () => void;

}

interface State {
    closeFocus: boolean;
}

export class NoCcfModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { closeFocus: false }
    }

    zoom(value: number, unit: "px" | "em") {
        return `${value * this.props.zoom}${unit}`;
        }

    onMouseEnter = () => {
        this.setState({
            closeFocus: true
        })
    }

    onMouseLeave = () => {
        this.setState({
            closeFocus: false
        })
    }

    render() {
        const closeModal = this.props.closeModal;
        const zoom = this.props.zoom;

        var closeClass = this.state.closeFocus ? "ui-dialog-titlebar-close ui-corner-all ui-state-hover" : "ui-dialog-titlebar-close ui-corner-all";


        return (

            <Modal
                show={true}
                animation={false}
                centered={true}
                onEscapeKeyDown={() => closeModal()}
                onHide={() => { /* don't allow hide via off-click*/ }}
                size="lg"
                enforceFocus={true}
                style={{ zIndex: 10001, background: "rgba(000, 000, 000, 0.5)" }}
          >
            <Draggable
              axis="both"
              handle=".ui-dialog-titlebar"
            >
                  <div className="ui-dialog ui-widget ui-widget-content ui-corner-all ui-draggable" tabIndex={-1} role="dialog" aria-labelledby="ui-dialog-title-2" style={{ display: 'block', zIndex: 10001, outline: '0px', height: 'auto', width: '300px', left: `${zoom * 375}px`, top: `${zoom * 750}px` }}>
                      <div className="ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix">
                          <span className="ui-dialog-title" id="ui-dialog-title-2">Silsolver</span>
                          <div className={closeClass} role="button">
                              <span className="ui-icon ui-icon-closethick" style={{ cursor: "pointer" }} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={() => closeModal()} >close</span>
                          </div>
                      </div>
                      <p className="ui-dialog-content ui-widget-content" style={{ display: 'block', width: 'auto', minHeight: '34.8667px', height: 'auto' }}>CCF is not used with 1oo1, 2oo2, or 3oo3 architectures.</p>
                      <div className="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
                          <div className="ui-dialog-buttonset">
                              <button type="button" onClick={() => closeModal()} >Ok</button>
                          </div>
                      </div>
                  </div>
              </Draggable>
            </Modal>
        );
    }
}